module.exports = __webpack_public_path__ + "static/media/okIcon.776298b7.svg";